export default __webpack_public_path__ + "static/media/Basic-Account.7ef6cc90.png";